module.exports = "<sellers-says></sellers-says>\r\n<app-footer></app-footer>"